/* global google */
import { Loader } from "@googlemaps/js-api-loader";

// Function to initialize the map
async function initMap(center, zoom, elementID = "mapCanvas", showUI) {
  try {
    const { Map } = await google.maps.importLibrary("maps");
    const map = new Map(document.getElementById(elementID), {
      center: center,
      zoom: zoom,
      mapId: "fee9d62b462803e" + elementID,

      // UI controls for the map
      mapTypeControl:
        showUI.mapTypeControl ?? (typeof showUI === "boolean" ? showUI : true),
      fullscreenControl:
        showUI.fullscreenControl ??
        (typeof showUI === "boolean" ? showUI : true),
      streetViewControl:
        showUI.streetViewControl ??
        (typeof showUI === "boolean" ? showUI : true),
      zoomControl:
        showUI.zoomControl ?? (typeof showUI === "boolean" ? showUI : true),
      disableDefaultUI:
        showUI.disableDefaultUI ??
        (typeof showUI === "boolean" ? !showUI : false),
      keyboardShortcuts:
        showUI.keyboardShortcuts ??
        (typeof showUI === "boolean" ? showUI : true),
      gestureHandling:
        showUI.gestureHandling ?? (typeof showUI === "boolean" ? showUI : true),

      options: {
        gestureHandling: "greedy",
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM,
        },
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM,
        },
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.BOTTOM_CENTER,
        },
      },
    });
    return map;
  } catch (error) {
    console.error("Error initializing Google Maps:", error);
  }
}

// Function to load the map
function loadGoogleMaps(center, zoom, mapElementID, showUI = {}) {
  const key = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
  const loader = new Loader({
    apiKey: key,
    version: "weekly",
  });

  // Return the Promise from loader.load()
  return loader.load().then(() => {
    // Return the Promise from initMap
    return initMap(center, zoom, mapElementID, showUI);
  });
}

export { loadGoogleMaps };
